import React from 'react';
import Header from '../components/Header';
import HeroCarousel from '../components/HeroCarousel';
import ModelsSection from '../components/ModelsSection';
import LoanCalculator from '../components/LoanCalculator';
import AdvisorsSection from '../components/AdvisorsSection';
import LocationSection from '../components/LocationSection';
import ReviewsSection from '../components/ReviewsSection';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="App">
      <Header />
      <HeroCarousel />
      <ModelsSection />
      <LoanCalculator />
      <AdvisorsSection />
      <LocationSection />
      <ReviewsSection />
      <ContactForm />
      <Footer />
    </div>
  );
};

export default Home;
